import {
  PRIORITY_OPTIONS,
  STATUS_OPTIONS,
  TASK_TYPE_OPTIONS,
} from "@/constants/tasks";

import { Tag } from "antd";

// Рендер тега при отображении приоритета задачи
export const renderPriorityTag = (priorities) => (props) => {
  const { label, value } = props;
  const priority = priorities.find((p) => p.uuid === value);

  const icon = PRIORITY_OPTIONS.find(
    (item) => item.value === priority?.color
  )?.icon;

  return (
    <Tag icon={icon} className="tag-with-icon">
      {label}
    </Tag>
  );
};

// Рендер опции приоритета задачи в селекте
export const renderPriorityOption = (option) => {
  const icon = PRIORITY_OPTIONS.find(
    (item) => item.value === option.data.color
  )?.icon;
  return (
    <Tag icon={icon} className="tag-with-icon">
      {option.label}
    </Tag>
  );
};

// Рендер тега при отображении статуса задачи
export const renderStatusTag = (statuses) => (props) => {
  const { label, value } = props;
  const status = statuses.find((s) => s.uuid === value);
  const icon = STATUS_OPTIONS.find(
    (item) => item.value === status?.color
  )?.icon;
  return (
    <Tag icon={icon} color={status?.color} className="tag-with-icon-color">
      {label}
    </Tag>
  );
};

// Рендер опции статуса задачи в селекте
export const renderStatusOption = (option) => {
  const icon = STATUS_OPTIONS.find(
    (item) => item.value === option.data.color
  )?.icon;
  return (
    <Tag icon={icon} color={option.data.color} className="tag-with-icon-color">
      {option.label}
    </Tag>
  );
};

// Рендер тега при отображении типа задачи
export const renderTaskTypeTag = (taskTypes) => (props) => {
  const { label, value } = props;
  const taskType = taskTypes.find((t) => t.uuid === value);

  const icon = TASK_TYPE_OPTIONS.find(
    (item) => item.value === taskType?.style_key
  )?.icon;
  return (
    <Tag icon={icon} className="tag-with-icon lg">
      {label}
    </Tag>
  );
};

// Рендер опции типа задачи в селекте
export const renderTaskTypeOption = (option) => {
  const icon = TASK_TYPE_OPTIONS.find(
    (item) => item.value === option.data.style_key
  )?.icon;
  return (
    <Tag icon={icon} className="tag-with-icon lg">
      {option.label}
    </Tag>
  );
};
